export default "__VITE_ASSET__BrBAFgZH__"